import { Modal, Result } from '@bfe/moly';
import { useMemo } from 'react';

import { useI18nContext } from '@/i18n/I18n';
import { IDeleteAccountErrors } from '@/services/deleteAccount/types';

interface IConstants {
  assetlimit: number;
  registertimeinterval: number;
  registertimes: number;
}

const Reasons = ({
  businessUnitDetails,
  constants,
}: {
  businessUnitDetails: IDeleteAccountErrors['businessUnitDetails'];
  constants: IConstants;
}) => {
  const [$t] = useI18nContext();

  const reasons = useMemo(() => {
    return businessUnitDetails
      .map((detail) => {
        let msg = '';

        ['', '1', '2', '3', '4'].forEach((item, index) => {
          const suffix = index > 0 ? `_${index}` : '';
          const key = `deleteAccountReason_${detail.rejectCode}${suffix}`;
          if ($t(key) === key) {
            if (index === 0) {
              msg = detail.rejectReason;
            }
          } else {
            msg = `${msg ? `${msg} / ${$t(key)}` : $t(key)}`;
          }
        });

        msg = msg
          .replace(
            '{registertimeinterval}',
            `${constants.registertimeinterval}${$t('Insurance.Hour')}`,
          )
          .replace('{registertimes}', `${constants.registertimes}`)
          .replace('{{assetlimit}}', `${constants.assetlimit}`);
        return {
          msg,
          code: Array.isArray(detail)
            ? detail[0].rejectCode
            : detail.rejectCode,
        };
      })
      .filter((item) => !!item.msg);
  }, [businessUnitDetails, $t, constants]);

  return (
    <div className="unable-to-delete-reasons">
      <div className="unable-to-delete-reasons-title">
        {$t('unableToDeleteReasonsTitle')}
      </div>
      <ol>
        {reasons.map((reason) => (
          <li key={reason.code}>{reason.msg}</li>
        ))}
      </ol>
    </div>
  );
};

const DeleteAccountUnableReasonModal = ({
  visible,
  businessUnitDetails,
  constants,
  onClose,
}: {
  visible: boolean;
  businessUnitDetails: IDeleteAccountErrors['businessUnitDetails'];
  constants: IConstants;
  onClose: () => void;
}) => {
  const [$t] = useI18nContext();

  return (
    <Modal
      open={visible}
      cancelText={null}
      okText={$t('ok')}
      // () => {
      //   setShowErrorsModal(false);
      // }
      onOk={onClose}
      size="small"
      closable={false}
    >
      <Result
        className="unadble-to-delete-result"
        title={$t('unableToDelete')}
        subTitle={$t('unableToDeleteReasons')}
        extra={
          <Reasons
            businessUnitDetails={businessUnitDetails}
            constants={constants}
          />
        }
        status="error"
      ></Result>
    </Modal>
  );
};

export default DeleteAccountUnableReasonModal;
